import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

export default React.memo(props => (
  <SvgIcon {...props} width="17" height="16" viewBox="0 0 17 16" fill="none">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.00024 4.49996C4.00024 3.48744 4.82106 2.66663 5.83358 2.66663H10.0002C10.1329 2.66663 10.26 2.7193 10.3538 2.81307L13.1871 5.64641C13.2809 5.74017 13.3336 5.86735 13.3336 5.99996V11.5C13.3336 12.5125 12.5128 13.3333 11.5002 13.3333H5.83358C4.82106 13.3333 4.00024 12.5125 4.00024 11.5V4.49996ZM5.83358 3.66663C5.37334 3.66663 5.00024 4.03972 5.00024 4.49996V11.5C5.00024 11.9602 5.37333 12.3333 5.83358 12.3333H11.5002C11.9605 12.3333 12.3336 11.9602 12.3336 11.5V6.20707L9.79314 3.66663H5.83358Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.83358 2.83329C10.1097 2.83329 10.3336 3.05715 10.3336 3.33329V5.66663H12.6669C12.9431 5.66663 13.1669 5.89048 13.1669 6.16663C13.1669 6.44277 12.9431 6.66663 12.6669 6.66663H9.83358C9.55743 6.66663 9.33358 6.44277 9.33358 6.16663V3.33329C9.33358 3.05715 9.55743 2.83329 9.83358 2.83329Z"
      fill="currentColor"
    />
  </SvgIcon>
));
